module.exports = __webpack_public_path__ + "static/media/play-icon.9c651dcc.png";